import type { ModuleMigrationDef } from "@kubdee/sdk";

// ============================================================================
// 002_post_insights_snapshots
//
// Issue #792 — materialised social-post insights snapshots.
//
// Changes:
//   - Add provider_post_id so each snapshot is keyed by target + provider post.
//   - Make metric columns nullable. Provider APIs often omit a metric; NULL
//     means unavailable, while 0 means the provider explicitly returned zero.
//
// SQLite cannot drop NOT NULL constraints in-place, so rebuild the table and
// copy existing rows. Existing metric values are preserved as-is.
// ============================================================================

export const migration: ModuleMigrationDef = {
  key: "002_post_insights_snapshots",
  version: "0.2.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`marketing_post_insights_rebuild\` (
\t\`id\` text PRIMARY KEY NOT NULL,
\t\`company_id\` text NOT NULL,
\t\`target_id\` text NOT NULL,
\t\`provider_post_id\` text,
\t\`snapshotted_at\` text NOT NULL,
\t\`impressions\` integer,
\t\`reach\` integer,
\t\`likes\` integer,
\t\`comments\` integer,
\t\`shares\` integer,
\t\`clicks\` integer,
\t\`engagement_rate\` real,
\t\`raw_payload\` text,
\t\`created_at\` text NOT NULL,
\tFOREIGN KEY (\`target_id\`) REFERENCES \`marketing_post_targets\`(\`id\`) ON UPDATE no action ON DELETE cascade
);
INSERT OR IGNORE INTO \`marketing_post_insights_rebuild\` (
\t\`id\`,
\t\`company_id\`,
\t\`target_id\`,
\t\`provider_post_id\`,
\t\`snapshotted_at\`,
\t\`impressions\`,
\t\`reach\`,
\t\`likes\`,
\t\`comments\`,
\t\`shares\`,
\t\`clicks\`,
\t\`engagement_rate\`,
\t\`raw_payload\`,
\t\`created_at\`
)
SELECT
\ti.\`id\`,
\ti.\`company_id\`,
\ti.\`target_id\`,
\tt.\`provider_post_id\`,
\ti.\`snapshotted_at\`,
\ti.\`impressions\`,
\ti.\`reach\`,
\ti.\`likes\`,
\ti.\`comments\`,
\ti.\`shares\`,
\ti.\`clicks\`,
\ti.\`engagement_rate\`,
\ti.\`raw_payload\`,
\ti.\`created_at\`
FROM \`marketing_post_insights\` i
LEFT JOIN \`marketing_post_targets\` t ON t.\`id\` = i.\`target_id\`;
DROP TABLE \`marketing_post_insights\`;
ALTER TABLE \`marketing_post_insights_rebuild\` RENAME TO \`marketing_post_insights\`;
CREATE INDEX IF NOT EXISTS \`marketing_post_insights_company_id_idx\` ON \`marketing_post_insights\` (\`company_id\`);
CREATE INDEX IF NOT EXISTS \`marketing_post_insights_target_snapshot_idx\` ON \`marketing_post_insights\` (\`target_id\`, \`snapshotted_at\`);
CREATE INDEX IF NOT EXISTS \`marketing_post_insights_target_provider_snapshot_idx\` ON \`marketing_post_insights\` (\`target_id\`, \`provider_post_id\`, \`snapshotted_at\`);
  `.trim(),
};
